import { RefreshCw, Wifi } from 'lucide-react';

import { cn } from '@/lib/utils';

export type ConnectionStatus = 'connecting' | 'connected' | 'disconnected' | 'error';

const STATUS_CONFIG = {
  connected: {
    icon: Wifi,
    label: 'Live',
    className: 'bg-secondary/10 text-secondary',
    animate: false,
  },
  connecting: {
    icon: RefreshCw,
    label: 'Connecting...',
    className: 'bg-primary/10 text-primary',
    animate: true,
  },
  fallback: {
    icon: RefreshCw,
    label: 'Auto-refresh',
    className: 'bg-muted text-muted-foreground',
    animate: false,
  },
} as const;

/**
 * Socket connection pill: green "Live" when the realtime socket is up,
 * otherwise the polling-fallback state. Shared by the Activity tab and
 * the Live command center.
 *
 * @param props - Current socket connection status.
 */
export function ConnectionBadge({ status }: { status: ConnectionStatus }) {
  const config =
    status === 'connected'
      ? STATUS_CONFIG.connected
      : status === 'connecting'
        ? STATUS_CONFIG.connecting
        : STATUS_CONFIG.fallback;
  const Icon = config.icon;

  return (
    <div
      className={cn(
        'flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium',
        config.className,
      )}
    >
      <Icon className={cn('h-3.5 w-3.5', config.animate && 'animate-spin')} />
      {config.label}
    </div>
  );
}
